import { atom } from 'recoil';

export const authTokenForInvokeState = atom<string | null>({
  key: 'auth-token-for-invoke',
  default: null,
});
